import React from 'react';
export const ImgReactMessageTemplateImage = (props) => {
    return React.createElement("img", Object.assign({}, props, { onError: props.onError, referrerPolicy: "no-referrer" }));
};
